import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export function  generateGetters(state) {
    if(!_.isObject(state)) return {}

    // 按老逻辑转化getters
    return _.chain(state).keys().map(key => {
        return [
            key.replace(/([A-Z])/g, '_$1').toUpperCase(), 
            state => {
                return state[key]
            }
        ]
    }).fromPairs().value()
}

const state = {
    loginInfo: {},
    isLogin: false,
    couponSelected: null,
    payGlobal: null
}
const getters = generateGetters(state)

export function createStore(store = {}) {
    return new Vuex.Store({
        state: {
            ...state,
            ...store.state
        },
        mutations: {
            ...store.mutations,
            ...mutations
        },
        actions: {
            ...store.actions,
            ...actions
        },
        getters: {
            ...store.getters,
            ...getters
        },
        modules: {
            ...store.modules
        }
    })

}
